import { render, staticRenderFns } from "./ModuleTourdataMulti.vue?vue&type=template&id=9e2d48f2&scoped=true"
import script from "./ModuleTourdataMulti.vue?vue&type=script&lang=js"
export * from "./ModuleTourdataMulti.vue?vue&type=script&lang=js"
import style0 from "./ModuleTourdataMulti.vue?vue&type=style&index=0&id=9e2d48f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e2d48f2",
  null
  
)

export default component.exports